import angular from 'angular';

export const GiftCardRouterConstants = {
    TEMPLATES_ROUTE: 'web-gift-cards/templates/',
    CONFIGURATION_ROUTE: 'ib-gift-cards-configuration-view.html',
    PAYMENT_ROUTE: 'ib-pmt-view.html',
    CONFIRMATION_ROUTE: 'ib-pmt-gift-cards-confirmation-view.html',
    ERROR_ROUTE: 'ib-gift-cards-generic-error-view.html',
    PAGES_URL: {
        GIFTCARD_CONFIGURATION: '/configuration',
        GIFTCARD_CONTRIBUTION: '/contribution',
        GIFTCARD_ERROR: '/error',
        GIFTCARD_CONFIRMATION:'/giftcards-confirmation',
        GIFTCARD_PAYMENTS:'/ibpurco',
        GIFTCARD_NEW_CONFIRMATION:'/gc-new'
    }
};
angular.module('ib-gift-cards-routing-module').constant('GiftCardsRouterConstants', GiftCardRouterConstants);

export type GiftCardsRouterConstantsType = typeof GiftCardRouterConstants;
